import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import AndroidIcon from "@mui/icons-material/Android";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CloseIcon from "@mui/icons-material/Close";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentUser } from "../pages/auth/authSlice";
import { useGetTeacherSubjectsQuery } from "../pages/staff/staffApiSlice";
import { useMobileWebAppPrompt } from "../../hooks/useMobileWebAppPrompt";

function MobileAppDownloadPrompt() {
  const location = useLocation();
  const pathname = location?.pathname || "/";
  const { shouldPrompt, dismissPrompt, platform, storeUrl } =
    useMobileWebAppPrompt(pathname);

  const user = useSelector(selectCurrentUser);
  const isParent = user?.roles?.some((r) => r?.role?.name === "parent");
  const isStudent = user?.roles?.some((r) => r?.role?.name === "student");
  const isTeacher = user?.roles?.some((r) => r?.role?.name === "teacher");

  const { data: teacherSubjects } = useGetTeacherSubjectsQuery(undefined, {
    skip: !isTeacher,
  });
  const teacherHasSubjects = isTeacher && teacherSubjects?.length > 0;

  const allowedRole = isParent || isStudent || teacherHasSubjects;

  if (!shouldPrompt || !allowedRole) {
    return null;
  }

  const PlatformIcon =
    platform === "android" ? (
      <AndroidIcon sx={{ fontSize: 16 }} />
    ) : (
      <PhoneIphoneIcon sx={{ fontSize: 16 }} />
    );

  return (
    <Box
      sx={{
        bottom: 12,
        left: "50%",
        position: "fixed",
        transform: "translateX(-50%)",
        zIndex: (theme) => theme.zIndex.snackbar,
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        pointerEvents: "none",
      }}
    >
      <Chip
        component="a"
        href={storeUrl}
        target="_blank"
        rel="noopener noreferrer"
        icon={PlatformIcon}
        label="Get the Schoola app"
        size="small"
        clickable
        sx={{
          pointerEvents: "auto",
          fontWeight: 600,
          fontSize: "0.75rem",
          bgcolor: "background.paper",
          boxShadow: 3,
          border: "1px solid",
          borderColor: "divider",
          "& .MuiChip-label": { px: 1 },
        }}
      />
      <Tooltip title="Dismiss">
        <IconButton
          size="small"
          onClick={dismissPrompt}
          aria-label="Dismiss app download prompt"
          sx={{
            pointerEvents: "auto",
            bgcolor: "background.paper",
            boxShadow: 3,
            border: "1px solid",
            borderColor: "divider",
            width: 24,
            height: 24,
          }}
        >
          <CloseIcon sx={{ fontSize: 14 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
}

export default MobileAppDownloadPrompt;
